import {
  CountrySelect
} from "./chunk-PZZ6UZS4.mjs";
import {
  Input
} from "./chunk-SDBF3NFL.mjs";
import {
  __objRest,
  __spreadValues
} from "./chunk-32ZPS4GN.mjs";

// src/phone-input/index.tsx
import React, { useRef } from "react";
var PhoneInput = (_a) => {
  var _b = _a, {
    countryCode,
    disabled,
    error,
    id,
    maxDropdownHeight,
    name,
    onChange,
    onCountryChange,
    placeholder,
    positive,
    value
  } = _b, props = __objRest(_b, [
    "countryCode",
    "disabled",
    "error",
    "id",
    "maxDropdownHeight",
    "name",
    "onChange",
    "onCountryChange",
    "placeholder",
    "positive",
    "value"
  ]);
  const inputRef = useRef(null);
  const countrySelect = /* @__PURE__ */ React.createElement(
    CountrySelect,
    {
      countryCode,
      error,
      maxDropdownHeight,
      onCountryChange,
      positive,
      inputRef
    }
  );
  return /* @__PURE__ */ React.createElement(
    Input,
    __spreadValues({
      autoComplete: "tel-national",
      "data-testid": "phone-input",
      disabled,
      error,
      id,
      inputMode: "tel",
      ref: inputRef,
      name,
      onChange,
      positive,
      placeholder,
      type: "text",
      value,
      startEnhancer: countrySelect,
      className: { input: "!pl-1" },
      "aria-label": "Please enter a phone number without the country dial code."
    }, props)
  );
};
var phone_input_default = PhoneInput;

export {
  PhoneInput,
  phone_input_default
};
